export default "{\n    \"title\": \"Add Planned Maintenance\",\n    \"name\": \"Name\",\n    \"submitLabel\": \"Save\",\n    \"previewLabel\": \"Preview\"\n}\n"